import { HttpClient, HttpHeaders, HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { JsonResult } from "../core/json-result.model";
import { EnvironmentService } from "../core/services/environment.service";
import {
  PaymentItems,
  PaymentOperation,
} from "../models/payment-operation.models";
import { Payment, Respuesta } from "../models/Payment.model";
import { PaymentEmail } from "../models/PaymentEmail.model";
import { CommonService } from "./common.service";
import { takeUntil } from "rxjs/operators";
import { CardToken } from "../models/card-token.model";
import { of } from "rxjs";

@Injectable({
  providedIn: "root",
})
export class PaymentService {
  private controller: string = "PaymentBill";
  constructor(
    private httpClient: HttpClient,
    private environmentService: EnvironmentService,
    private commonService: CommonService
  ) {}

  CreatePayment(order: Payment) {
    let url = `${this.environmentService.virtualOfficeServiceUrl}${this.controller}/CreatePayment`;
    return this.httpClient.post<JsonResult<Respuesta>>(url, order);
  }
  GetPaymentBill(order: PaymentItems) {
    let url = `${this.environmentService.virtualOfficeServiceUrl}${this.controller}/GetPaymentBill`;
    let params = new HttpParams();
    params = params.append("orderId", order.orderId.toString());
    params = params.append("transactionId", order.transactionId.toString());
    // params = params.append("acceptCommerce", order.acceptCommerce.toString());
    // params = params.append("clientCode", order.clientCode.toString());
    // params = params.append("interlocutorId", order.interlocutorId.toString());

    return this.httpClient.get<JsonResult<any>>(url, { params: params });
  }
  SendVoucherPayment(paymentEmail: PaymentEmail) {
    let url = `${this.environmentService.virtualOfficeServiceUrl}${this.controller}/SendVoucherPayment`;
    return this.httpClient.post<JsonResult<any>>(url, paymentEmail);
  }
  DownloadVoucher(order: PaymentItems) {
    let url = `${this.environmentService.virtualOfficeServiceUrl}${this.controller}/DownloadVoucher`;
    let params = new HttpParams();
    params = params.append("orderId", order.orderId.toString());
    params = params.append("transactionId", order.transactionId.toString());
    return this.httpClient.get<JsonResult<any>>(url, { params: params });
  }
  PaymentCardToken() {
    let url = `${this.environmentService.virtualOfficeServiceUrl}${this.controller}/PaymentCardToken`;
    return this.httpClient
      .get<JsonResult<CardToken[]>>(url)
      .pipe(takeUntil(this.commonService.unauthorizedAnnounced));
  }
  PaymentCardTokenDelete(id: number) {
    //    let options = { params: httpParams };
    let url =
      `${this.environmentService.virtualOfficeServiceUrl}${this.controller}/PaymentCardToken/` +
      id;
    return this.httpClient.delete<JsonResult<any>>(url);
  }

  /*  PaymentNotification(response: any) {
    let url = `${this.environmentService.virtualOfficeServiceUrl}${this.controller}/PaymentNotification`;

    // Validar el tipo de response
    if (typeof response === "object") {
      if (Array.isArray(response)) {
        console.log("Response is an array.");
      } else {
        console.log("Response is an object.");
      }
    } else {
      console.log(`Response is of type ${typeof response}.`);
    }

    console.log("PaymentNotification service", response);
    return this.httpClient.post<JsonResult<any>>(url, response.toString());
  } */

  PaymentNotificationInterno(response: any) {
 let url = `${this.environmentService.virtualOfficeServiceUrl}${this.controller}/PaymentNotificationInterno`;

    let body = new URLSearchParams();
    body.set("response", JSON.stringify(response));

    let headers = new HttpHeaders({
      "Content-Type": "application/x-www-form-urlencoded",
    });

    //console.log("PaymentNotification service", response);

    return this.httpClient.post<JsonResult<any>>(url, body.toString(), {
      headers: headers,
    }); 
   

  /*   const mockResponse = {
      success: true,
      message: "Payment notification received successfully.",
      data: { transactionId: "12345", status: "COMPLETED" },
    };
  
    // Simula la promesa que devuelve el HttpClient
    return of(mockResponse); // `of` es de `rxjs` */
  }
}
